import { render, staticRenderFns } from "./tabBranches.vue?vue&type=template&id=6486f7ee&"
import script from "./tabBranches.vue?vue&type=script&lang=js&"
export * from "./tabBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports